module.exports = __webpack_public_path__ + "media/images/favicon-d6f8d3f44a020d0c6485efeda94e19ac.ico";